export default "__VITE_ASSET__C5AgHwS$__"